import styled from 'styled-components';

export const InfoRow = styled.div`
  display: flex;
  width: 100%;
`;
